import { ReactNode } from 'react';
import { Sample, SampleProps } from './sample';

type StateData = Omit<SampleProps, 'className'> & { view?: boolean };

export type ContainerDataProps = {
  error?: StateData;
  empty?: StateData;
  info?: StateData;
  children: ReactNode;
  loading?: boolean;
  className?: string;
};

/**
 * Компонент обертка для данных.
 *
 * Отобразит одно из состояний данных:
 * - загрузка
 * - ошибка
 * - пустые данные
 * - сами данные
 */
export const DataContainer = (props: ContainerDataProps) => {
  if (props.loading) {
    return (
      <Sample className={props.className}>
        <span className="text-primary-900 inline-flex items-end gap-1">
          Loading...
        </span>
      </Sample>
    );
  }

  if (props.error?.view) {
    return (
      <Sample
        imageName={props.error.imageName || 'profiling'}
        title={props.error.title || 'Ошибка'}
        message={props.error.message}
        button={props.error.button}
        className={props.className}
      />
    );
  }

  if (props.info?.view) {
    return (
      <Sample
        imageName={props.info.imageName || 'new-chat'}
        title={props.info.title}
        message={props.info.message}
        button={props.info.button}
        className={props.className}
      />
    );
  }

  if (props.empty?.view) {
    return (
      <Sample
        imageName={props.empty?.imageName || 'new-chat'}
        title={props.empty.title}
        message={props.empty.message}
        button={props.empty.button}
        className={props.className}
      />
    );
  }

  return props.children;
};
